import type { BannerWrapperProps } from './LearnerCard.styles';
import { BannerWrapper } from './LearnerCard.styles';

export type BannerProps = {
  label: string;
  variant?: BannerWrapperProps['$variant'];
};

export const Banner = ({ label, variant = 'danger' }: BannerProps) => (
  <BannerWrapper size={0} weight="bold" $variant={variant}>
    {label}
  </BannerWrapper>
);
